const prefill = ({ session, product = {}, address = {} }) => {
  if ( !session ) return
  console.log(session.value)
  setField( "firm[customernr]", session.value.map_id )
  setField( "firm[name]", session.value.title )
  //setField( "person[firstname]", address.name2 )
  //setField( "person[lastname]", address.name3 )
  setField( "address[street]", session.value.street )
  setField( "address[postcode]", session.value.pcode )
  setField( "address[city]", session.value.city )
  setField( "content[subject]", "" )
  setField( "contact[email]", session.value.email )
  setField( "contact[phone]", session.value.phone )

  //setOption( "person[salutation]", address.name1 )
  // setField( "extra[catalog]", session.value.map_id )
  // setField( "extra[sendbills]", session.value.map_id )
}

const setField = (selector, value) => {
  let field = document.querySelector( `input[name='${selector}']` )
  if ( field && value ) field.value = value
}

const setOption = (selector, value) => {
  let field = document.querySelector( `select[name='person[salutation]']` )
  if ( field ) field.value = value
}

export default prefill



// WEBPACK FOOTER //
// ./src/theme/hobbyfun/components/Form/prefill.js